import { SITE_FETCHED ,SET_SITE,SITE_DOOR} from "../types";

const initialState = {
  siteData: [] as any,
  singleSite:{},
  siteDoor:[] as any
};
const sites = (state = initialState, action: any) => {
  switch (action.type) {
    case SITE_FETCHED:
      return {
        ...state,
        siteData: action.siteData,
        loading: false,
      };
       case SITE_DOOR:
      return {
        ...state,
        siteDoor: action.siteDoor,
        // loading: false,
      };
    case SET_SITE:
      return {
        ...state,
        singleSite: action.singleSite,
        // loading: false,
      };
    default:
      return state;
  }
};

export default sites;



